<template>
  <div :id="id"
    :style="{ width: '95%', height: '100%', margin: '0 auto' }"></div>
</template>

<script>
export default {
  props: {
    chartsData: {
      type: Object | Array,
      default: () => ({} | []),
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    id: {
      type: String | Number,
      default: "1",
    },
    type: {
      type: String,
      default: "lightLine",
    },
    usePropsOptions: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  watch: {
    chartsData: {
      handler(newvalue, oldvalue) {
        this.drawLine();
      },
      deep: true,
    },
  },

  methods: {
    async drawLine() {
      // console.log(this.chartsData);
      if (document.getElementById(this.id) == null) {
        return;
      }
      let myChart = this.$echarts.getInstanceByDom(
        document.getElementById(this.id)
      );
      if (!myChart) {
        myChart = this.$echarts.init(document.getElementById(this.id));
      }
      myChart.setOption({}, true);
      let option = this.options;
      if (!this.usePropsOptions) {
        let utils = await import(`../assets/chartOption/${this.type}.js`);
        option = {
          ...utils.setOption(this.chartsData),
          ...this.options,
        };
      }
      myChart.setOption(option, true);
      if (this.id == "getImgId") {
        this.$parent.img = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff",
        });
      } else if (this.id == "getDepartmentImg") {
        this.$parent.departmentImg = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff",
        });
      } else if (this.id == "getSystemImg") {
        this.$parent.systemImg = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff",
        });
      } else if (this.id == "getRegionImg") {
        this.$parent.regionImg = myChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff",
        });
      }
      setTimeout(() => {
        window.addEventListener("resize", () => {
          myChart.resize();
        });
      }, 20);
    },
  },
  mounted() {
    this.drawLine();
  },
};
</script>

<style scoped lang="scss"></style>
